import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { TaxCertLabel, CountryCode } = Constants;

export const ILTaxViewTaxForm = (props) => {
  const { i18n } = props;
  const taxCertLabel = i18n.getString(TaxCertLabel.TaxCertificateOrEquivalentProof);

  return (
    <GlobalViewTaxForm
      {...props}
      taxCertLabel={taxCertLabel}
      countryCode={CountryCode.IL}
    />
  );
};

ILTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
